import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SkeletonTableLoad from "../../../components/SkeletonTableLoad";
import { CountryTable } from "../../../models/Admin/CountryTables";
import msalRestClient from "../../../services/clients/MsalRestClient";

const CountryTablesOverview = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [selectedVersion, setSelectedVersion] = useState<number>(1);
    const [countryTables, setCountryTables]     = useState<CountryTable[]>([]);

    useEffect(() => {
        fetchCountryTables();
    }, [])

    /**
     * Method fetches a collection of all availiable countryTables.
     */
    async function fetchCountryTables() {

        setIsLoading(true);

        /* Fetch data from backend service */
        msalRestClient.get<CountryTable[]>("/api/countrytables/autocomplete")
            .then(response => {
                if (response.status === 200) {
                    /* Set fetched CountryTables to the current state */
                    setCountryTables(response.data);
                }
                else if (response.status === 204) {
                    /* No countryTable could be found for the specified filter, set state to empty collection */
                    setCountryTables([]);
                }
            })
            .catch(error => { })
            .finally(() => setIsLoading(false));
    }

    /* JSX Element for Rendering within browser */
    return (
        <main className="container">
            <div className="row">

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}>
                                                    <label>Table</label>
                                                    <div className="input-group mt-2">
                                                        <select className="form-select mb-2" defaultValue={selectedVersion} onChange={e => setSelectedVersion(Number(e.target.value))}>
                                                            {
                                                                countryTables.map((value, index) => {
                                                                    return (
                                                                        <option value={value.id}>{value.name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                        <div className="input-group-append">
                                                            <NavLink to={"/admin/countries/" + selectedVersion} className="btn btn-primary">
                                                                <i className="bi bi-pen"></i>
                                                            </NavLink>
                                                            <NavLink to={"/admin/countries/copy/" + selectedVersion} className="btn btn-warning">
                                                                <i className="bi bi-clipboard"></i>
                                                            </NavLink>
                                                            <NavLink to={"/admin/countries/create"} className="btn btn-success">
                                                                <i className="bi bi-plus-lg"></i>
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th colSpan={2}></th>
                                            </tr>
                                            <tr>
                                                <th>#</th>
                                                <th>Origin Country</th>
                                                <th>Destination Country</th>
                                                <th>Refund Rate</th>
                                                <th>
                                                    { /* Empty for Controls */ }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                countryTables.find(x => x.id === selectedVersion)?.countrySet.sort(x => x.id).map((x, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{x.id}</td>
                                                            <td>{x.sourceCountry}</td>
                                                            <td>{x.targetCountry}</td>
                                                            <td>{x.refundRate} &euro;</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )
}
export default CountryTablesOverview; 